import React, { useState, useEffect } from 'react';
import './Hero.css'
import { useNavigate } from 'react-router-dom';

export const Hero2 = () => {
  const [currentSlide, setCurrentSlide] = useState(0);



  const slides = [
    {
      image: 'https://firebasestorage.googleapis.com/v0/b/flutter-chat-app-e4b52.firebasestorage.app/o/qinto_app_images%2Ffor_web%2Fusp%2FUSP_Home_1.png?alt=media&token=a2029700-bfdb-4cc5-846f-17d52cadea31',
      heading: 'Snap, List, Sell.',
      subheading: 'It’s That Simple.',
      description: 'Our AI recognizes your item from a single photo, writing a compelling title and description for you automatically.',
    },
    {
      image: 'https://firebasestorage.googleapis.com/v0/b/flutter-chat-app-e4b52.firebasestorage.app/o/qinto_app_images%2Ffor_web%2Fusp%2FUSP_3.jpg?alt=media&token=8c28f283-970c-4281-9def-eecd84b27073',
      heading: 'Smart Categories.',
      subheading: 'Zero Guesswork.',
      description: 'Qinto automatically categorizes your item and generates a custom form, ensuring you never miss a detail.',
    },
    {
      image: 'https://firebasestorage.googleapis.com/v0/b/flutter-chat-app-e4b52.firebasestorage.app/o/qinto_app_images%2Ffor_web%2Fusp%2FUSP_Chat_1.jpg?alt=media&token=2f6e5055-fa66-4d53-b5ca-aabff5f3fc12',
      heading: 'Chat Securely.',
      subheading: 'Transact Locally.',
      description: 'Connect with buyers in your area through our secure in-app chat. No need to share your phone number.',
    }
  ];

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide(prevSlide => (prevSlide + 1) % slides.length);
    }, 5000);
    return () => clearInterval(slideInterval);
  }, [slides.length]);

  return (
    <section className="hero-section">
      {/* Background Decor Elements for the "Glossy" feel */}
      <div className="hero-bg-glow"></div>

      <div className="container hero-container">

        {/* LEFT SIDE: Static Hook + Dynamic Text */}
        <div className="hero-text-content">
          <div className="badge-pill">
            <span>✨ AI-Powered Marketplace</span>
          </div>

          {/* We keep the main title static for SEO and stability */}
          <h1 className="main-title">
            Buy & Sell Smarter.<br />
            <span className="highlight-text">Absolutely Free.</span>
          </h1>

          {/* Dynamic Description Carousel */}
          <div className="text-carousel-wrapper">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`text-slide ${index === currentSlide ? 'active' : ''}`}
              >
                <h3 className="slide-heading">{slide.heading} <span style={{ opacity: 0.7 }}>{slide.subheading}</span></h3>
                <p className="slide-description">{slide.description}</p>
              </div>
            ))}
          </div>

          {/* <div className="hero-buttons">
            <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer" className="btn btn-primary-glossy">
              <span className="icon">▶</span> Google Play
            </a>
            <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer" className="btn btn-secondary-glossy">
              <span className="icon"></span> App Store
            </a>
          </div> */}


          <div className="hero-buttons">
            {/* ACTIVE Google Play Button */}
            <a
              href="https://play.google.com/store/apps/details?id=com.qinto.qintoapp" /* PUT YOUR ACTUAL LINK HERE */
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary-glossy"
            >
              {/* Google Play Icon SVG */}
              <img src="/logos/google-play-svgrepo-com.png" alt="Play Store Logo" className='logo-play-store' />
              <div>
                <span style={{ fontSize: '10px', display: 'block', lineHeight: '1' }}>GET IT ON</span>
                <span style={{ fontSize: '16px' }}>Google Play</span>
              </div>
            </a>

            {/* PASSIVE App Store Button (Coming Soon) */}
            <div className="btn btn-secondary-glossy disabled" style={{ cursor: 'default', opacity: 0.7 }}>
              {/* Apple Icon SVG */}
              <img src="/logos/apple-173-svgrepo-com.png" alt="App Store Logo" className='logo-play-store' />
              <div>
                <span style={{ fontSize: '10px', display: 'block', lineHeight: '1' }}>Coming Soon on</span>
                <span style={{ fontSize: '16px' }}>App Store</span>
              </div>
            </div>
          </div>

        </div>

        {/* RIGHT SIDE: Phone Mockup Visual */}
        <div className="hero-visual-content">
          <div className="phone-mockup">
            <div className="phone-notch"></div>

            {/* Image Carousel inside the phone */}
            <div className="screen-content">
              {slides.map((slide, index) => (
                <img
                  key={index}
                  src={slide.image}
                  alt={slide.heading}
                  loading="lazy"
                  className={`screen-image ${index === currentSlide ? 'active' : ''}`}
                />
              ))}
            </div>
          </div>

          {/* Floating Elements for depth */}
          <div className="floating-card card-1">
            <span>📸 AI Scan</span>
          </div>
          <div className="floating-card card-2">
            <span>🚀 Fast Post</span>
          </div>
        </div>

      </div>

      {/* Dots navigation at bottom for mobile primarily */}
      <div className="carousel-dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentSlide === index ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </section>
  );
};



export const Hero = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabsData = [
    {
      navTitle: 'Snap, List, Sell',
      heading: 'Snap, List, Sell.',
      subheading: 'It’s That Simple.',
      description: 'Our AI recognizes your item from a single photo, writing a compelling title and description for you automatically.',
      image: 'assets/hero/point_shoot_pov.webp',
    },
    {
      navTitle: 'Smart Categories',
      heading: 'Smart Categories.',
      subheading: 'Zero Guesswork.',
      description: 'Qinto automatically categorizes your item and generates a custom form, ensuring you never miss a detail. It perceives, it thinks, it organizes.',
      // High-res placeholder to see the background bleed effect
      image: 'assets/hero/lady_with_categories.webp',
    },
    {
      navTitle: 'Secure Chat',
      heading: 'Chat Securely.',
      subheading: 'Transact Locally.',
      description: 'Connect with buyers in your area through our secure in-app chat. Your transactions, your privacy, our priority.',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=2670&auto=format&fit=crop',
    }
  ];

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setActiveTab(prevSlide => (prevSlide + 1) % tabsData.length);
    }, 6000);
    return () => clearInterval(slideInterval);
  }, [tabsData.length]);

  return (
    <section className="qinto-bleed-hero">

      {/* BACKGROUND BASE: Qinto Purple Gradient */}
      <div className="bleed-hero-bg"></div>

      {/* TOP NAVIGATION (Matched to Reference) */}
      {/* <div className="bleed-nav-wrapper">
        <div className="bleed-nav-container">
          {tabsData.map((tab, index) => (
            <button 
              key={index} 
              className={`bleed-nav-btn ${activeTab === index ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
              {tab.navTitle}
            </button>
          ))}
        </div>
      </div> */}

      <div className="bleed-content-wrapper">

        {/* RIGHT SIDE: The Massive Bleeding Image Layer (Sits BEHIND Text) */}
        <div className="bleed-image-layer">
          <img
            src={tabsData[activeTab].image}
            alt={tabsData[activeTab].heading}
            className={`bleed-bg-image fade-transition`}
            key={activeTab} // Forces re-render for css animation
          />
        </div>

        {/* LEFT SIDE: Text Overlapping Content (Sits ON TOP of Image) */}
        <div className="bleed-text-layer">
          <div className="title-wrapper">
            <h1 className="bleed-heading">{tabsData[activeTab].heading}</h1>
            <h2 className="bleed-subheading">{tabsData[activeTab].subheading}</h2>
          </div>

          <p className="bleed-description">{tabsData[activeTab].description}</p>

          {/* Buttons mimicking the grid blocks from the reference image */}
          {/* <div className="bleed-action-grid">
            <a
              href="https://play.google.com/store/apps/details?id=com.qinto.qintoapp"
              target="_blank"
              rel="noopener noreferrer"
              className="action-btn active-btn"
            >
              <img src="/logos/google-play-svgrepo-com.png" alt="Play Store" className='store-logo' />
              <div className="btn-text">
                <span className="btn-small">GET IT ON</span>
                <span className="btn-large">Google Play</span>
              </div>
            </a>

            <div className="action-btn passive-btn">
              <img src="/logos/apple-173-svgrepo-com.png" alt="App Store" className='store-logo' />
              <div className="btn-text">
                <span className="btn-small">Coming Soon on</span>
                <span className="btn-large">App Store</span>
              </div>
            </div>
          </div> */}
          <div className="bleed-nav-container">

            <h1 className="bleed-todo-text">Browse & Post 2x faster in the app</h1>
            {/* <p style={{color: "#fff"}}>Download the app now</p> */}
          </div>

          <div className="hero-buttons">
            {/* ACTIVE Google Play Button */}
            <a
              href="https://play.google.com/store/apps/details?id=com.qinto.qintoapp" /* PUT YOUR ACTUAL LINK HERE */
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary-glossy"
            >
              {/* Google Play Icon SVG */}
              <img src="/logos/google-play-svgrepo-com.png" alt="Play Store Logo" className='logo-play-store' />
              <div>
                <span style={{ fontSize: '10px', display: 'block', lineHeight: '1' }}>GET IT ON</span>
                <span style={{ fontSize: '16px' }}>Google Play</span>
              </div>
            </a>

            {/* PASSIVE App Store Button (Coming Soon) */}
            <div className="btn btn-secondary-glossy disabled" style={{ cursor: 'default', opacity: 0.7 }}>
              {/* Apple Icon SVG */}
              <img src="/logos/apple-173-svgrepo-com.png" alt="App Store Logo" className='logo-play-store' />
              <div>
                <span style={{ fontSize: '10px', display: 'block', lineHeight: '1' }}>Coming Soon on</span>
                <span style={{ fontSize: '16px' }}>App Store</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;